<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>Work Item</md-icon>
                    </div>
                    <h4 class="title">Edit Work Item</h4>
                </md-card-header>

                <form @submit.prevent="update">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="workItem.name" />
                                    <validation-error :errors="apiValidationErrors.name" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Date
                            </label>
                            <div class="md-layout-item">
                                <md-datepicker
                                        v-model="workItem.date"
                                        :md-model-type="String"
                                        :class="{ 'md-invalid': !!apiValidationErrors.date }"
                                >
                                    <label>Select date ...</label>
                                    <validation-error :errors="apiValidationErrors.date" />
                                </md-datepicker>
                            </div>
                        </div>

                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Activity
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="workItem.activity.id" name="activities">
                                        <md-option
                                                v-for="activity in available_activities_dropdown"
                                                :key="activity.id"
                                                :value="activity.id"
                                        >
                                            {{ activity.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                               Work Place
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="workItem.workplace.id" name="workplaces">
                                        <md-option
                                                v-for="workplace in available_workplaces_dropdown"
                                                :key="workplace.id"
                                                :value="workplace.id"
                                        >
                                            {{ workplace.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Guidance
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="workItem.guidance.id" name="guidances">
                                        <md-option
                                                v-for="guidance in available_guidances_dropdown"
                                                :key="guidance.id"
                                                :value="guidance.id"
                                        >
                                            {{ guidance.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                               Activity Tariff
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="workItem.activityTariff.id" name="activity_tariffs">
                                        <md-option
                                                v-for="activity_tariff in available_activity_tariffs_dropdown"
                                                :key="activity_tariff.id"
                                                :value="activity_tariff.id"
                                        >
                                            {{ activity_tariff.amount }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Update Work Item</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>

<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';

export default {
    components: { ValidationError },

    mixins: [formMixin],

    data: () => ({
        workItem: {
            type: 'workItems',
            name: null,
            date: null,
            activity: {
                id: null,
                type: 'activities',
            },
            workplace: {
                id: null,
                type: 'workplaces',
            },
            guidance: {
                id: null,
                type: 'guidances',
            },
            activityTariff: {
                id: null,
                type: 'activityTariffs',
            },
            relationshipNames: ['activity','work','activityTariff'],
        },
        available_activities_dropdown: [],
        available_workplaces_dropdown: [],
        available_guidances_dropdown: [],
        available_activity_tariffs_dropdown: [],

    }),

    created () {
        this.get();
        this.getActivities();
        this.getWorkplaces();
        this.getGuidances();
        this.getActivityTariffs();
    },
    methods: {
        async get () {
            try {
                const id = this.$route.params.id;
                // return service.get(id)
                //     .then((response)=>{
                //         console.log(response);
                //     });
                // console.log(this.$store.dispatch("activities/get", id));
                await this.$store.dispatch('workItems/get', id);
                console.log(this.$store.getters);
                this.workItem = this.$store.getters['workItems/workItem'];
                console.log(this.workItem);
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },

        async update () {
            if (
                this.$isDemo == 1 &&
                    ['1', '2', '3'].includes(this.$route.params.id)
            ) {
                await this.$store.dispatch(
                    'alerts/error',
                    'You are not allowed to change data of default roles.'
                );
                return;
            }
            try {
                await this.$store.dispatch('workItems/update', this.workItem);
                await this.$store.dispatch(
                    'alerts/success',
                    'Work Item updated successfully.'
                );
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].detail
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }
            }
        },
        getActivities () {
            this.$store.dispatch('activities/list').then(() => {
                //  console.log(this.$store)
                this.available_activities_dropdown = this.$store.getters['activities/list'];
                // console.log(this.available_activities_dropdown)
            });
        },
        getWorkplaces () {
            this.$store.dispatch('workplaces/list').then(() => {
                this.available_workplaces_dropdown = this.$store.getters['workplaces/dropdown'];
            });
        },
        getGuidances () {
            this.$store.dispatch('guidances/list').then(() => {
                this.available_guidances_dropdown = this.$store.getters['guidances/dropdown'];
            });
        },
        getActivityTariffs () {
            this.$store.dispatch('activityTariffs/list').then(() => {
                this.available_activity_tariffs_dropdown = this.$store.getters['activityTariffs/dropdown'];
            });
        },

        goBack () {
            this.$router.push({ name: 'Work Items List' });
        },
    },
};
</script>
